import { ParsedUrlQuery } from 'querystring';

export function getPriceFrequency(query: ParsedUrlQuery) {
    if (query['price_frequency']) {
        return query['price_frequency'];
    }

    return '';
}
